import React from 'react';
export function ContactPage() {
  return <section className="w-full bg-white text-secondary-800 text-base leading-7 font-sans rounded-xl shadow-2xl overflow-hidden" data-id="element-56">
      <div className="bg-gradient-to-br from-primary-700 via-primary-600 to-primary-800 text-white py-16 px-8 relative overflow-hidden" data-id="element-57">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=80')",
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-58"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-900/20 to-transparent" data-id="element-59"></div>
        <div className="relative z-10" data-id="element-60">
          <h1 className="font-display text-4xl md:text-6xl font-bold mb-6 text-center leading-tight" data-id="element-61">
            CONTACT US
          </h1>
          <p className="text-center text-xl md:text-2xl max-w-3xl mx-auto text-primary-50 font-medium" data-id="element-62">
            Need to ask us a question or want to chat?
          </p>
        </div>
      </div>
      <div className="px-8 py-16 max-w-2xl mx-auto" data-id="element-63">
        <div className="backdrop-blur-sm bg-white/80 rounded-2xl p-10 shadow-xl border border-secondary-100" data-id="element-64">
          <p className="text-center text-secondary-600 text-xl mb-8 leading-relaxed" data-id="element-65">
            Email us at{' '}
            <a href="mailto:info@EarlyWarning.Report" className="text-primary-600 font-semibold hover:text-primary-700 hover:underline transition-colors" data-id="element-66">
              info@EarlyWarning.Report
            </a>{' '}
            and we will get back to you shortly.
          </p>
        </div>
      </div>
    </section>;
}